{
  "familyId": "SWW-VT-ZULLEN-KUNNEN",
  "questions": [
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-001",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd van 'zullen' in: 'Ik ... morgen komen.'?",
      "options": ["zou", "zal", "zulde", "gezuld"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hulpwerkwoorden VT", "content": "Zullen, kunnen, willen en mogen zijn onregelmatige hulpwerkwoorden. Zullen → zou/zouden. Kunnen → kon/konden. Willen → wilde/wilden. Mogen → mocht/mochten.", "icon": "lightbulb"}}],
      "conceptId": "vt_zullen",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Zullen' is een onregelmatig hulpwerkwoord. De verleden tijd is: ik zou, wij zouden. Niet 'zulde' — dat bestaat niet.",
        "solutionSteps": ["Zullen is onregelmatig", "Enkelvoud VT: zou", "Meervoud VT: zouden"],
        "distractorExplanations": {
          "0": "Goed! Zullen → zou (enkelvoud).",
          "1": "Je hebt de tegenwoordige tijd geschreven (ik zal). De verleden tijd van zullen is zou. Onthoud: zullen → zou/zouden.",
          "2": "Je dacht waarschijnlijk dat je -de achter de stam zet. Maar 'zullen' is onregelmatig — 'zulde' bestaat niet. Onthoud: zullen → zou.",
          "3": "Je dacht waarschijnlijk aan het voltooid deelwoord. Maar 'gezuld' bestaat niet. Zullen heeft geen normaal VD. Onthoud: zullen → zou (VT)."
        }
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-002",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd van 'kunnen' in: 'Zij ... goed zwemmen.'?",
      "options": ["kon", "kan", "kunde", "gekunnen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Kunnen → kon", "content": "Kunnen is onregelmatig. Enkelvoud VT: kon. Meervoud VT: konden.", "icon": "lightbulb"}}],
      "conceptId": "vt_kunnen",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "'Kunnen' is onregelmatig. De verleden tijd is: zij kon (enkelvoud), zij konden (meervoud). Hier is 'zij' enkelvoud, dus: kon.",
        "solutionSteps": ["Kunnen is onregelmatig", "Enkelvoud VT: kon", "Meervoud VT: konden"],
        "distractorExplanations": {
          "0": "Goed! Kunnen → kon (enkelvoud VT).",
          "1": "Je hebt de tegenwoordige tijd geschreven (zij kan). De verleden tijd is kon. Onthoud: kunnen → kon/konden.",
          "2": "Je dacht waarschijnlijk dat je -de achter de stam zet. Maar 'kunde' bestaat niet als werkwoordsvorm. Onthoud: kunnen → kon.",
          "3": "Je dacht aan het voltooid deelwoord. Maar de vraag vraagt naar de verleden tijd. Kunnen → kon (VT), gekund (VD). Onthoud: VT ≠ VD."
        }
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-003",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct?",
      "options": ["Wij zouden graag meedoen.", "Wij zouwen graag meedoen.", "Wij zulden graag meedoen.", "Wij zou graag meedoen."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Meervoud van zou", "content": "Enkelvoud: ik/jij/hij zou. Meervoud: wij/jullie/zij zouden. Niet 'zouwen' of 'zulden'.", "icon": "lightbulb"}}],
      "conceptId": "vt_zullen_meervoud",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het meervoud van 'zou' is 'zouden'. 'Wij zouden graag meedoen' is correct.",
        "solutionSteps": ["Wij = meervoud", "Zou (enkelvoud) → zouden (meervoud)", "Wij zouden graag meedoen"],
        "distractorExplanations": {
          "0": "Goed! Wij zouden is de correcte meervoudsvorm.",
          "1": "Je dacht waarschijnlijk dat het meervoud 'zouwen' is. Maar dat bestaat niet. Het meervoud van zou is zouden. Onthoud: zou → zouden.",
          "2": "Je dacht waarschijnlijk dat je -den achter 'zul' zet. Maar 'zulden' bestaat niet. De VT van zullen is zou/zouden. Onthoud: zullen → zou/zouden.",
          "3": "Je hebt de enkelvoudsvorm gebruikt bij een meervoudsonderwerp. 'Wij' is meervoud, dus je schrijft 'zouden', niet 'zou'. Onthoud: wij/jullie/zij → zouden."
        }
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-004",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd van 'mogen' in: 'Hij ... niet meedoen.'?",
      "options": ["mocht", "mag", "mogde", "gemogen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Mogen → mocht", "content": "Mogen is onregelmatig. Enkelvoud VT: mocht. Meervoud VT: mochten.", "icon": "lightbulb"}}],
      "conceptId": "vt_mogen",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Mogen' is onregelmatig. De verleden tijd is: hij mocht (enkelvoud), zij mochten (meervoud).",
        "solutionSteps": ["Mogen is onregelmatig", "Enkelvoud VT: mocht", "Meervoud VT: mochten"],
        "distractorExplanations": {
          "0": "Goed! Mogen → mocht.",
          "1": "Je hebt de tegenwoordige tijd geschreven (hij mag). De verleden tijd is mocht. Onthoud: mogen → mocht/mochten.",
          "2": "Je dacht waarschijnlijk dat je -de achter de stam zet. Maar 'mogde' bestaat niet. Onthoud: mogen → mocht.",
          "3": "Je dacht aan het voltooid deelwoord. Maar de vraag vraagt naar de verleden tijd. Onthoud: VT van mogen = mocht."
        }
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-005",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "fill_in",
      "question": "Vul de verleden tijd in: De kinderen ... (willen) graag een ijsje.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["wilden"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Willen → wilde/wilden", "content": "Willen is onregelmatig. Enkelvoud VT: wilde. Meervoud VT: wilden. 'De kinderen' = meervoud → wilden.", "icon": "lightbulb"}}],
      "conceptId": "vt_willen_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'De kinderen' is meervoud. De VT van willen (meervoud) is wilden.",
        "solutionSteps": ["De kinderen = meervoud", "Willen → wilde (enkelvoud), wilden (meervoud)", "Antwoord: wilden"]
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-006",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "fill_in",
      "question": "Vul in: Vorig jaar ... (kunnen) zij goed zwemmen.",
      "correctAnswer": "kon",
      "data": {
        "acceptedAnswers": ["kon"],
        "placeholder": "verleden tijd van kunnen",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kunnen in de VT", "content": "Kunnen → kon (enkelvoud) / konden (meervoud). 'Zij' is hier enkelvoud → kon.", "icon": "lightbulb" } }
      ],
      "conceptId": "vt_kunnen_fill_in",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Vorig jaar' = verleden tijd. 'Zij' is hier enkelvoud. Kunnen → kon (enkelvoud VT). Dus: 'Vorig jaar kon zij goed zwemmen.'",
        "solutionSteps": [
          "Signaalwoord: 'vorig jaar' → verleden tijd",
          "Onderwerp: 'zij' → enkelvoud",
          "Kunnen → kon (enkelvoud VT)"
        ]
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-007",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "matching",
      "question": "Koppel elk hulpwerkwoord aan de juiste verleden tijd (enkelvoud).",
      "correctAnswer": null,
      "data": {
        "pairs": [
          { "left": "zullen", "right": "zou" },
          { "left": "kunnen", "right": "kon" },
          { "left": "willen", "right": "wilde" },
          { "left": "mogen", "right": "mocht" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hulpwerkwoorden VT", "content": "Zullen → zou/zouden. Kunnen → kon/konden. Willen → wilde/wilden. Mogen → mocht/mochten. Dit zijn onregelmatige werkwoorden — je moet ze uit je hoofd leren.", "icon": "lightbulb" } }
      ],
      "conceptId": "vt_hulpww_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De verleden tijd van deze hulpwerkwoorden is onregelmatig: zullen → zou, kunnen → kon, willen → wilde, mogen → mocht. Deze vormen moet je uit je hoofd kennen.",
        "solutionSteps": [
          "Zullen → zou (niet zulde)",
          "Kunnen → kon (niet kunde)",
          "Willen → wilde (niet wilte)",
          "Mogen → mocht (niet mogde)"
        ]
      }
    }
  ]
}